import { BronzeConsistencyIncentiveSection } from '@sections/BronzeConsistencyIncentiveSection'
import { BronzeIncentivesSection } from '@sections/BronzeIncentivesSection'
import { BusinessSection } from '@sections/BusinessSection'
import { DepthSection } from '@sections/DepthSection'
import { FrontlinesSection } from '@sections/FrontlinesSection'
import { LeadershipPlusIncentiveSection } from '@sections/LeadershipPlusIncentiveSection'
import { PerformancePlusSection } from '@sections/PerformancePlusSection'
import { SectionComponentClass } from '@sections/SectionComponent'
import { TwoTimeCashIncentiveSection } from '@sections/TwoTimeCashIncentiveSection'

export function simulatorPageSection(): SectionComponentClass[] {
  const sections = [
    BusinessSection,
    FrontlinesSection,
    DepthSection,
    BronzeIncentivesSection,
    BronzeConsistencyIncentiveSection,
    PerformancePlusSection,
    LeadershipPlusIncentiveSection,
    TwoTimeCashIncentiveSection
  ]

  return sections
}
